import { Component, createRef, Fragment } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import cx from 'classnames'
import { animateScroll } from 'react-scroll'
import Table from 'rc-table'
import { PRODUCT_SHIP_TYPE, PROPOSAL_EXECUTE_STATUS, EXPIRING_NOTE } from '@vzmi/shp_shared_compo/constants/proposal'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'
import 'rc-table/assets/index.css'

import styles from './index.css'
import {
  InputField,
  RadioGroupInputField,
  CheckboxInputField,
  InputCountField,
  FormError
} from '../../../../../../Common/Form'
import Information from '../../../../../../Common/Information'
import FormValueSelector from '../../../../../../Common/forms/FormValueSelector'
import { Field } from '../../../../../../Common/forms'
import { eventPreventDefault, numeralFormat } from '../../../../../../../../lib/renderUtil'
import {
  filterFileListByError,
  getHasAnyErrorFile,
  getIsAnyFileUploading
} from '../../../../../../../lib/uploaderUtil'
import { Icon } from '@vzmi/shp_shared_compo'
import Image from '../../../../../../Common/Image'
import { LimitDescBtwCostAndStock } from '../../../../../Common/ProposalForm/FormLabelTooltip/FormLabelTooltip'
import YPopover from '../../../../../../Common/Popover'
import { FORM_ERROR_CLASS_NAME } from '../../../../../../../styles/variables'
import { required } from '../../../../../../../lib/FormHelper'
import { noEmoji } from '../../../../../../../lib/Validator'
import { validateModelImages } from '../../../../../Common/ProposalForm/Shared/validation/fieldLevelValidator'
import SingleLineText from '../../../../../Common/ReadOnlyComponents/SingleLineText/SingleLineText'
import { ListingFieldConfig } from '../../../../../Common/ProposalForm/Shared/FieldConfig'
import ImageUploaderField from '../../../../../Common/ImageUploader/ImageUploaderField'
import {
  convertUploaderDataToProposalImages,
  organizeImageFileList
} from '../../../../../Common/ImageUploader/ImageUploaderHelper'
import {
  formatAll,
  showOnlyNumber,
  showNoLessThan,
  showUnderInputNumberLimit,
  showRoundedNumber
} from '../../../../../../../lib/formatter'
import {
  IMAGE_UPLOADER_MAX_FILE,
  COMPOSE_SECTION_OFFSET,
  INVALID_TRANSIENT_KEY
} from '../../../../../Shared'
import { stockValidation, skipRequiredThenValidate } from '../../../../../Common/ProposalForm/Shared/validation/validations'
import { determineSpecLevel, getAttrTableFieldPrefixByLevel, getScopedShipTypeSectionName, MAX_PRODUCT_NAME_IN_EXPRESS_24HR } from '../../../../../Common/ProposalForm/Shared/util'
import { isNewListingProposal } from '../../../../../../../../lib/proposalHelper'
import { length } from 'redux-form-validators'

const lengthMax = max => value => length({ max, msg: '字數超過上限' })(value)
const TableTitle = ({ children }) => (
  <div className={styles.TableTitle}>
    {children}
  </div>
)
const tableRowType = {
  ROW_MODEL_TOP: 1, // 相同model的第一個item row
  ROW_MODEL_ITEM: 2, // 相同model的其他item row
  ROW_INFORM: 3, // 顯示調整進倉名稱editor row
  ROW_INFORM_HIDE: 4 // "不"顯示調整進倉名稱editor row
}

const ExpandImageButton = props => {
  const {
    children,
    className,
    readOnly,
    expanded,

    shareImageFieldName,
    syncImageFieldName,

    isImageShared,
    isImageSynced,
    isImageSharedTagContent,
    isHiddenCounterOnInvalid,

    enableShare,
    enableCopy,
    enableSync,
    enableCopyToAllModels,
    invalid,
    images,
    maxFile,
    onExpandImageClick,
    onCopyImagesClick,
    onShareImagesClick,
    onSyncImageClick,
    onCopyToAllModels,
    ...restProps
  } = props

  const hasAnyErrorImage = getHasAnyErrorFile(images)
  const isAnyFileUploading = getIsAnyFileUploading(images)
  const validImages = filterFileListByError(images)
  const isHiddenCounter = isHiddenCounterOnInvalid && (invalid || _.isEmpty(validImages))
  const imagesLength = _.size(validImages)
  const isShowPreviewImage = imagesLength >= 1 && !isAnyFileUploading
  const isInvalidField = invalid || hasAnyErrorImage || isAnyFileUploading
  const previewImage = isShowPreviewImage
    ? (
      <Image
        key='images'
        data-role='expand-image-button-thumbnail'
        src={_.get(validImages, '[0].url')}
      />
    )
    : null

  let tagContent = expanded
    ? '收合'
    : (
      readOnly
        ? '展開'
        : (
          <>
            <Icon
              size={12}
              color='#fff'
              align='initial'
              name='compose'
            />
            編輯
          </>
        )
    )

  if (isImageShared) {
    tagContent = _.isNil(isImageSharedTagContent)
      ? '圖片已共用'
      : isImageSharedTagContent
  }

  const expandClickable = !isAnyFileUploading && !isImageShared

  return (
    <>
      <div
        key='imageButton'
        data-role='expand-image-button'
        {...restProps}
        className={styles.ExpandImageButton}
        onClick={expandClickable ? onExpandImageClick : null}
      >
        <div
          key='figure'
          className={cx(styles.figure, {
            [styles.preview]: isShowPreviewImage,
            [styles.invalid]: isInvalidField,
            [FORM_ERROR_CLASS_NAME]: isInvalidField
          })}
        >
          {previewImage}
          {!isShowPreviewImage && (
            <Icon
              key='new'
              name='fuji2/plus'
              color='#4A6DFB'
              size={24}
            />
          )}
          <div
            key='tag'
            className={cx(styles.tag, {
              [styles.expandHint]: !expanded && isShowPreviewImage
            })}
          >
            {tagContent}
          </div>
        </div>
        {!isHiddenCounter && (
          <small
            key='indicator'
            className={cx(styles.indicator, {
              [styles.valid]: isShowPreviewImage && !isInvalidField,
              [styles.invalid]: isInvalidField
            })}
          >
            {`(${imagesLength}/${maxFile})`}
          </small>
        )}
        {(enableCopyToAllModels && !isInvalidField) && (
          <small>
            <a
              href='#'
              onClick={onCopyToAllModels}
              className={cx(styles.indicator, styles.valid)}
            >
              以下全同
            </a>
          </small>
        )}
      </div>
      {enableShare && (
        <Field
          label='共用同組商品圖'
          key='shareMediaBetweenModels'
          name={shareImageFieldName}
          data-role={'table-row-shareMediaBetweenModels'}
          component={CheckboxInputField}
          disabled={readOnly}
          onChange={(e, newValue, oldValue) => onShareImagesClick(newValue)}
        />
      )}
      {enableSync && (
        <Field
          label='同時修改商品圖'
          key='enableSync'
          name={syncImageFieldName}
          component={CheckboxInputField}
          disabled={readOnly}
        />
      )}
      {/* 先關閉複製商品圖功能
      {enableCopy && isShowPreviewImage && !isInvalidField && (
        <HyperLink
          href='#'
          data-role='copy-images'
          onClick={e => {
            eventPreventDefault(e)
            onCopyImagesClick(images)
          }}>複製同組商品圖</HyperLink>
      )} */}
    </>
  )
}

/** 商品圖片功能元件 */
export const ImageFunction = props => {
  const {
    input = {},
    meta = {},

    isImageSynced,
    syncImageFieldName,
    enableSync,

    maxFile,
    readOnly,
    children,
    className,
    isImageShared,
    isImageSharedTagContent,
    isHiddenCounterOnInvalid = false,
    shareImageFieldName,
    expanded,
    enableCopy,
    enableShare,
    enableCopyToAllModels,
    onCopyToAllModels,

    onShareImagesClick,
    onCopyImagesClick,
    onExpandImageClick,
    onSyncImageClick,
    ...restProps
  } = props

  const { invalid, touched } = meta
  const images = input.value || []
  const isAnyFileUploading = getIsAnyFileUploading(images)

  return (
    <div
      data-role='image-function'
      {...restProps}
      className={styles.ImageFunction}
    >
      <ExpandImageButton
        key='button'
        readOnly={readOnly}
        images={images}
        maxFile={maxFile}
        enableCopy={enableCopy}
        enableShare={enableShare}
        enableSync={enableSync}
        enableCopyToAllModels={enableCopyToAllModels}
        isImageSynced={isImageSynced}
        isImageShared={isImageShared}
        isImageSharedTagContent={isImageSharedTagContent}
        isHiddenCounterOnInvalid={isHiddenCounterOnInvalid}
        shareImageFieldName={shareImageFieldName}
        syncImageFieldName={syncImageFieldName}
        expanded={expanded}
        invalid={isAnyFileUploading || (invalid && touched)}
        onCopyImagesClick={onCopyImagesClick}
        onShareImagesClick={onShareImagesClick}
        onExpandImageClick={onExpandImageClick}
        onSyncImageClick={onSyncImageClick}
        onCopyToAllModels={onCopyToAllModels}
      />
      <FormError
        key='error'
        {...meta}
        showFormError={(touched && invalid) || isHiddenCounterOnInvalid}
      />
    </div>
  )
}

// 此時進來的fileList為已上傳的圖片
// 為了知道目前上傳狀態必須將整理過(有檔案上傳狀態)的檔案，將有錯誤的物件一起拋給ImageUploaderField再存入redux state
export const handleImageFileFinish = fileList => {
  if (_.isEmpty(fileList)) {
    return fileList
  }
  const flattenFileList = convertUploaderDataToProposalImages(organizeImageFileList(fileList))
  return flattenFileList
}

export const handleImageFileUpdate = fileList => {
  if (_.isEmpty(fileList)) {
    return fileList
  }
  // filter out error so it won't trigger redux-form validation that lights up the image button
  const flattenFileList = convertUploaderDataToProposalImages(fileList)
  return flattenFileList
}

/**
 * This component should be imported under transient FormSection or it will break the data structure
 * Table data is generated from AttributeSpecField
 */
export class AttributeTable extends Component {
  constructor (props) {
    super(props)
    this.state = {
      initProductName: this.props.productName || ''
    }
    this.debouncer = createRef()
  }
  // NOTE: enable it if it hits performance bottleneck
  // shouldComponentUpdate (nextProps, nextState) {
  //   const { data, shipTypeId, expandedRowKeys } = this.props
  //   // only render when spec options and ship type id changes
  //   if (!_.isEqual(expandedRowKeys, nextProps.expandedRowKeys) || !_.isEqual(data, nextProps.data) || !_.isEqual(shipTypeId, nextProps.shipTypeId)) {
  //     return true
  //   }
  //   return false
  // }

  componentWillReceiveProps (nextProps) {
    const { shipTypeId: originShipTypeId, transientModel = {}, hasSpecLevel } = this.props
    const { forceInitTable } = nextProps
    const nextTransientModel = _.get(nextProps, 'transientModel', {})
    const { spec = [] } = transientModel
    const { spec: nextSpec } = nextTransientModel
    // only re-model when spec options changes or ship type id changes
    const isSpecChanged = !_.isEmpty(spec) &&
    !_.isEmpty(nextSpec) &&
    !_.isEqual(spec, nextSpec)
    const isSpecLevelChange = hasSpecLevel !== nextProps.hasSpecLevel
    const shipTypeId = +originShipTypeId

    if (
      isSpecChanged ||
      isSpecLevelChange ||
      forceInitTable ||
      !_.isEqual(this.props.data, nextProps.data) ||
      !_.isEqual(shipTypeId, +nextProps.shipTypeId)
    ) {
      // user 重新選擇規格表後會重置商品屬性為空陣列
      // 在使用者重新上傳商品圖片、選擇屬性後才會產生 data
      // 如果少了 debouncer 會因為大量狀態變化 render 到超過上限拋錯
      this.debouncer.current && clearTimeout(this.debouncer.current)
      this.debouncer.current = setTimeout(() => {
        this.initTable(nextProps)
      }, 300)
    }
  }

  componentDidMount () {
    this.initTable()
  }

  initTable = (props = this.props) => {
    const { data, shipTypeId, transientField, transientModel } = props
    switch (shipTypeId) {
      case PRODUCT_SHIP_TYPE.EXPRESS_24HR: {
        // 當配送方式選擇"快速到貨"，則備貨數量 = 0，不可調整
        _.map(data, localData => {
          const { fieldName } = localData
          const stockFieldName = `${transientField}.${fieldName}.stock`
          const warehouseFieldName = `${transientField}.${fieldName}.warehouseProductName`
          this.props.triggerFieldChange(stockFieldName, '0')
          this.props.triggerFieldChange(warehouseFieldName, localData.warehouseProductName)
        })
        break
      }
      case PRODUCT_SHIP_TYPE.ESD: {
        _.map(data, localData => {
          const { fieldName } = localData
          // 實際國際條碼 當配送方式選擇"ESD"，則不顯示此欄位
          const barcodeFieldName = `${fieldName}.barcode`
          if (_.get(transientModel, barcodeFieldName)) {
            this.props.triggerFieldChange(`${transientField}.${barcodeFieldName}`, '')
          }
        })
        break
      }
      default: {
        _.map(data, localData => {
          const { fieldName } = localData
          // 進倉用國際條碼 配送方式不是選擇"快速到貨"時，則清空
          const warehouseBarcodeFieldName = `${fieldName}.warehouseBarcode`
          if (_.get(transientModel, warehouseBarcodeFieldName)) {
            this.props.triggerFieldChange(`${transientField}.${warehouseBarcodeFieldName}`, '')
          }
        })
        break
      }
    }
  }

  getTransientExpandedRowKeysField = () => {
    const { tableFieldPrefix, transientField } = this.props
    return `${transientField}.${tableFieldPrefix}.expandedRowKeys`
  }

  resetExpandRow = () => {
    const { triggerFieldChange } = this.props
    triggerFieldChange(this.getTransientExpandedRowKeysField(), [])
  }

  makeColumnObject = (isFirstColumn, rowItem, rowIndex, isExpiringItem, readOnly, children) => {
    const { fieldName, warehouseProductName = '' } = rowItem
    const warehouseFieldName = `${fieldName}.warehouseProductName`
    let colSpan = 1
    if (!_.isEmpty(warehouseProductName)) {
      colSpan = isFirstColumn ? 5 : 0
      const countLimit = isExpiringItem ? MAX_PRODUCT_NAME_IN_EXPRESS_24HR - EXPIRING_NOTE.STR.length : MAX_PRODUCT_NAME_IN_EXPRESS_24HR
      children = (
        <>
          <span>
            <Icon
              name={'ec-information-fill'}
              size={17}
              align='top'
              color='#edc9cf'
            />
          </span>
          <span>
            {' 進倉用標籤/品名需為50個字內，請調整並確認內容是可供倉庫辨識的：'}
          </span>
          <div data-role='inform-row-input'>
            <Field
              key='warehouseProductName'
              type='text'
              name={warehouseFieldName}
              disabled={readOnly}
              data-role={`table-row-${rowIndex}-warehouseProductName`}
              component={InputCountField}
              addonBefore={isExpiringItem ? EXPIRING_NOTE.STR : ''}
              countLimit={countLimit}
              validate={[
                lengthMax(countLimit),
                required({ msg: '欄位不可為空' }),
                noEmoji({ msg: '請勿使用表情符號' })
              ]}
            />
          </div>
        </>
      )
    }

    return {
      children,
      props: {
        colSpan
      }
    }
  }

  getColumnConfig = field => {
    const {
      readOnly,
      specs,
      shipTypeId: originShipTypeId,
      expandedRowKeys = [],
      triggerFieldChange,
      isExpiringItem,
      flags,
      showErrorOnActive,
      mustShowFormError
    } = this.props
    const shipTypeId = +originShipTypeId

    // 有選項下，單層
    const hasOnlyOneSpecLayer = !_.isEmpty(specs) && _.size(specs) === 1
    const barcodeFeatureToggle = getFeatureToggle(flags, 'sp_bc14')

    switch (field) {
      case 'images': {
        return {
          title: <TableTitle>
            商品圖片
            <div className={styles.imageSub}>
              (2到10張）
            </div>
          </TableTitle>,
          dataIndex: 'images',
          key: 'images',
          width: 162,
          className: styles.images,
          render: (value, rowItem, index) => {
            const {
              key: rowKey,
              rowType,
              tablePrefixField,
              modelsLength,
              modelIndex,
              modelField,
              spec,
              images
            } = rowItem
            const isTwoLayerModel = !_.isEmpty(spec)
            const isCopyImagesToAllModelsDisabled = _.isEmpty(images)
            // 圖片以下全同 enable 條件
            // 雙層賣場 & 已經有上傳圖片 & 第一筆商品 & 修改頁
            const enableCopyToAllModels = (
              isTwoLayerModel &&
              !isCopyImagesToAllModelsDisabled &&
              index === 0 &&
              !readOnly
            )

            const imageFunctionId = `table-row-${index}-image-function`
            const isExpanded = _.includes(expandedRowKeys, rowKey)
            // scroll down to get closer to uploader and store expandedRowKeys to redux state

            const onExpandImageClick = () => {
              let localExpandedRowKeys = [...expandedRowKeys]
              if (_.includes(expandedRowKeys, rowKey)) {
                localExpandedRowKeys = _.difference(localExpandedRowKeys, [rowKey])
              } else {
                localExpandedRowKeys.push(rowKey)
              }

              triggerFieldChange(this.getTransientExpandedRowKeysField(), _.uniq(localExpandedRowKeys))

              // scroll down 100px and add current row key to expandedRowKeys
              if (!isExpanded) {
                const imageBoxEl = document.querySelector(`[data-role="${imageFunctionId}"]`)
                imageBoxEl && animateScroll.scrollMore(
                  imageBoxEl.getBoundingClientRect().top + COMPOSE_SECTION_OFFSET.SECTION_OFFSET
                )
              }
            }

            // copy images to other models on copy images button click
            const onCopyImagesClick = (images) => {
              const { triggerFieldChange, transientField } = this.props
              _.times(modelsLength, idx => {
                if (idx !== modelIndex) {
                  triggerFieldChange(`${transientField}.${tablePrefixField}.models[${idx}].images`, images)
                }
              })
            }

            const onCopyToAllModels = e => {
              e.preventDefault()
              e.stopPropagation()
              onCopyImagesClick(
                // 複製圖片避免狀態非 done 會導致複製過去的圖片顯示還在上傳中
                _.map(images, image => ({ ...image, status: 'done' }))
              )
              // 只展開複製來源列，其他列隱藏起來展開時列重新 render 才會顯示正確複製過去的商品圖片
              triggerFieldChange(this.getTransientExpandedRowKeysField(), [rowKey])
            }

            // handle clicking on `共用同組商品圖`
            const onShareImagesClick = isClicked => {
              // copy the images to all of models to avoid syncing issue when moving model order
              const {
                transientField,
                triggerFieldChange
              } = this.props

              let expandedRowKeys = []
              if (isClicked) {
                expandedRowKeys = [rowKey]
              }
              triggerFieldChange(
                `${transientField}.${tablePrefixField}.models[0].shareImageModel`,
                isClicked
              )
              triggerFieldChange(this.getTransientExpandedRowKeysField(), expandedRowKeys)
            }

            const shareImageFieldName = `${tablePrefixField}.shareMediaBetweenModels`
            const modelTop = rowType === tableRowType.ROW_MODEL_TOP
            const children = modelTop && (
              <FormValueSelector fieldName={shareImageFieldName}>
                {
                  shareMediaBetweenModels => {
                  /**
                   * we use the first model to display the images data,
                   * but we copy the images to all of models to avoid syncing issue when moving model order
                   */

                    // example: table.withLevel.models[0]
                    const dynamicModelField = shareMediaBetweenModels
                      ? `${tablePrefixField}.models[0]`
                      : modelField

                    const fieldName = `${dynamicModelField}.images`

                    return (
                      <Field
                        name={fieldName}
                        data-role={imageFunctionId}
                        readOnly={readOnly}
                        maxFile={IMAGE_UPLOADER_MAX_FILE}
                        enableCopy={modelTop && modelsLength > 1}
                        enableShare={modelTop && modelIndex === 0 && hasOnlyOneSpecLayer}
                        enableCopyToAllModels={enableCopyToAllModels}
                        isImageShared={modelIndex !== 0 && hasOnlyOneSpecLayer && shareMediaBetweenModels}
                        shareImageFieldName={shareImageFieldName}
                        onExpandImageClick={onExpandImageClick}
                        onCopyImagesClick={onCopyImagesClick}
                        onShareImagesClick={onShareImagesClick}
                        onCopyToAllModels={onCopyToAllModels}
                        expanded={isExpanded}
                        component={ImageFunction}
                        validate={validateModelImages}
                      />
                    )
                  }}
              </FormValueSelector>
            )
            return this.makeColumnObject(true, rowItem, index, isExpiringItem, readOnly, children)
          }
        }
      }

      case 'stock': {
        return {
          dataIndex: 'stock',
          key: 'stock',
          className: styles.stock,
          width: 144,
          title: (
            <TableTitle>
              <YPopover
                content={(
                  <FormValueSelector
                    withoutPrefix
                    fieldName='product.cost'
                  >
                    {cost => (
                      <>
                        備貨數量
                        <br />
                        請留意成本與數量限制：
                        <br />
                        <br />
                        {`• 成本：${numeralFormat(cost, { format: '0', allowZero: true })}`}
                        <br />
                        <LimitDescBtwCostAndStock />
                      </>
                    )}
                  </FormValueSelector>
                )}
              >
                備貨數量
                <Information className={styles.info} />
              </YPopover>
            </TableTitle>
          ),
          render: (value, rowItem, index) => {
            const {
              fieldName,
              modelField,
              tablePrefixField,
              enableTopRowFunction,
              copyStockToModel,
              modelsLength,
              itemsLength
            } = rowItem

            const disabled = readOnly || shipTypeId === PRODUCT_SHIP_TYPE.EXPRESS_24HR
            const stockFieldName = `${fieldName}.stock`
            const children = (
              <>
                <Field
                  key='stock'
                  disabled={disabled}
                  name={stockFieldName}
                  customDefaultValue='0'
                  data-role={`table-row-${index}-stock`}
                  component={
                    readOnly
                      ? SingleLineText
                      : InputField
                  }
                  format={formatAll(
                    showOnlyNumber,
                    showRoundedNumber,
                    showNoLessThan(0),
                    showUnderInputNumberLimit
                  )}
                  validate={skipRequiredThenValidate(required({ msg: '請輸入備貨數量' }), stockValidation)}
                  placeholder='輸入備貨數量'
                  showErrorOnActive={showErrorOnActive}
                  mustShowFormError={mustShowFormError}
                />
                {
                  !disabled && enableTopRowFunction && (
                    <FormValueSelector
                      key='copyStock'
                      fieldName={stockFieldName}
                    >
                      {(stock) => (
                        <a
                          href='#'
                          tabIndex='0'
                          onClick={e => {
                            eventPreventDefault(e)

                            if (!stock) { return }
                            const { triggerFieldChange, transientField } = this.props
                            if (copyStockToModel) {
                              _.times(modelsLength, idx => {
                                triggerFieldChange(`${transientField}.${tablePrefixField}.models[${idx}].items[0].stock`, stock)
                              })
                            } else {
                              _.times(itemsLength, idx => {
                                triggerFieldChange(`${transientField}.${modelField}.items[${idx}].stock`, stock)
                              })
                            }
                          }}
                        >
                          以下全同
                        </a>
                      )}
                    </FormValueSelector>
                  )
                }
              </>
            )
            return this.makeColumnObject(false, rowItem, index, isExpiringItem, readOnly, children)
          }
        }
      }

      case 'partNo': {
        return {
          dataIndex: 'partNo',
          key: 'partNo',
          title: (
            <TableTitle>
              <YPopover
                key='tooltip'
                content={(
                  <>
                    同MPN(製造商零件編號)
                    <br />
                    訂單成立時, 只會帶入各屬性項目所輸入的供應商商品料號
                  </>
                )}
              >
                供應商商品料號
                <Information className={styles.info} />
              </YPopover>
              <span
                key='sub'
                className={styles.sub}
              >
                {'(非必填'}
              </span>
            </TableTitle>
          ),
          render: (value, rowItem, index) => {
            const { fieldName } = rowItem
            const fieldConfig = ListingFieldConfig.getField('model.partNo')
            const children = (
              <Field
                {...fieldConfig}
                name={`${fieldName}.partNo`}
                data-role={`table-row-${index}-partNo`}
                className={styles.partNo}
                component={
                  readOnly
                    ? SingleLineText
                    : fieldConfig.component
                }
              />
            )
            return this.makeColumnObject(false, rowItem, index, isExpiringItem, readOnly, children)
          }
        }
      }

      case 'warehouseBarcode': {
        return {
          dataIndex: 'warehouseBarcode',
          key: 'warehouseBarcode',
          width: 220,
          className: styles.warehouseBarcode,
          title: (
            <TableTitle>
              <YPopover
                content={(
                  <>
                    倉庫驗收時的依據，若與進倉商品標示的條碼不符，
                    <br />
                    將無法驗收，此條碼為唯一值不可重覆
                  </>
                )}
              >
                進倉用國際條碼
                <Information className={styles.info} />
              </YPopover>
            </TableTitle>
          ),
          render: (value, rowItem, index) => {
            const { fieldName } = rowItem
            const children = (
              <>
                <Field
                  key='hasWarehouseBarcode'
                  name={`${fieldName}.hasWarehouseBarcode`}
                  buttonStyle='outline'
                  data-role='warehouse-barcode-radio'
                  className={styles.warehouseBarcodeRadio}
                  component={RadioGroupInputField}
                  disabled={readOnly}
                  options={[{ label: '系統產生', value: false }, { label: '自訂條碼', value: true }]}
                />
                <FormValueSelector
                  key='warehouseBarcode'
                  fieldName={`${fieldName}.hasWarehouseBarcode`}
                >
                  {(hasWarehouseBarcode = false) => {
                    const fieldConfig = barcodeFeatureToggle
                      ? ListingFieldConfig.getField('model.warehouseBarcode')
                      : ListingFieldConfig.getField('model.warehouseBarcodeOld')
                    return hasWarehouseBarcode && (
                      <Field
                        {...fieldConfig}
                        name={`${fieldName}.warehouseBarcode`}
                        disabled={readOnly}
                        data-role={`table-row-${index}-warehouseBarcode`}
                        showErrorOnActive={showErrorOnActive}
                        mustShowFormError={mustShowFormError}
                      />
                    )
                  }}
                </FormValueSelector>
              </>
            )
            return this.makeColumnObject(false, rowItem, index, isExpiringItem, readOnly, children)
          }
        }
      }

      case 'barcode': {
        return {
          title: (
            <TableTitle key='barcode'>
              <YPopover
                key='tooltip'
                content={(
                  <>
                    網站/搜尋引擎搜尋商品時使用，
                    <br />
                    請確認填入正確以利精準搜尋
                  </>
                )}
              >
                實際國際條碼
                <Information className={styles.info} />
                <span
                  key='sub'
                  className={styles.sub}
                >
                  {'(非必填）'}
                </span>
              </YPopover>
            </TableTitle>
          ),
          dataIndex: 'barcode',
          key: 'barcode',
          width: 220,
          className: styles.barcode,
          render: (value, rowItem, index) => {
            const { fieldName } = rowItem
            const fieldConfig = barcodeFeatureToggle
              ? ListingFieldConfig.getField('model.barcode')
              : ListingFieldConfig.getField('model.barcodeOld')
            const children = (
              <>
                <Field
                  {...fieldConfig}
                  component={
                    readOnly
                      ? SingleLineText
                      : InputField
                  }
                  name={`${fieldName}.barcode`}
                  data-role={`table-row-${index}-barcode`}
                  showErrorOnActive={showErrorOnActive}
                  mustShowFormError={mustShowFormError}
                />
              </>
            )
            return this.makeColumnObject(false, rowItem, index, isExpiringItem, readOnly, children)
          }
        }
      }

      case 'barcodeAndPartNo': {
        return {
          dataIndex: 'barcodeAndPartNo',
          key: 'barcodeAndPartNo',
          className: styles.barcodeAndPartNo,
          title: (
            <>
              <TableTitle key='barcode'>
                <YPopover
                  key='tooltip'
                  content={(
                    <>
                      網站/搜尋引擎搜尋商品時使用，
                      <br />
                      請確認填入正確以利精準搜尋
                    </>
                  )}
                >
                  實際國際條碼
                  <Information className={styles.info} />
                  <span
                    key='sub'
                    className={styles.sub}
                  >
                    (非必填）
                  </span>
                </YPopover>
              </TableTitle>
              <TableTitle key='partNo'>
                <YPopover
                  key='tooltip'
                  content={(
                    <>
                      同MPN(製造商零件編號)
                      <br />
                      訂單成立時, 只會帶入各屬性項目所輸入的供應商商品料號
                    </>
                  )}
                >
                  供應商商品料號
                  <Information className={styles.info} />
                </YPopover>
                <span
                  key='sub'
                  className={styles.sub}
                >
                  (非必填）
                </span>
              </TableTitle>
            </>
          ),
          render: (value, rowItem, index) => {
            const { fieldName } = rowItem
            const fieldConfig = barcodeFeatureToggle
              ? ListingFieldConfig.getField('model.barcode')
              : ListingFieldConfig.getField('model.barcodeOld')
            const children = (
              <>
                <Field
                  key='barcode'
                  {...fieldConfig}
                  component={
                    readOnly
                      ? SingleLineText
                      : InputField
                  }
                  name={`${fieldName}.barcode`}
                  data-role={`table-row-${index}-barcode`}
                  showErrorOnActive={showErrorOnActive}
                  mustShowFormError={mustShowFormError}
                />
                <Field
                  key='partNo'
                  {...ListingFieldConfig.getField('model.partNo')}
                  component={
                    readOnly
                      ? SingleLineText
                      : InputCountField
                  }
                  name={`${fieldName}.partNo`}
                  data-role={`table-row-${index}-partNo`}
                  className={styles.barcodeAndPartNoField}
                />
              </>
            )
            return this.makeColumnObject(false, rowItem, index, isExpiringItem, readOnly, children)
          }
        }
      }
      default: {
        return {}
      }
    }
  }

  getColumns = () => {
    const {
      HOME,
      ESD,
      EXPRESS_24HR,
      HOME_STORE,
      E_DELIVERY,
      E_VOUCHER
    } = PRODUCT_SHIP_TYPE

    const {
      specs,
      shipTypeId,
      hasSpecLevel: originHasSpecLevel,
      executeStatus,
      isExpiringItem,
      readOnly
    } = this.props
    const {
      withSpecLevel: hasSpecLevel
    } = determineSpecLevel(originHasSpecLevel)

    let columns = []

    switch (shipTypeId) {
      case HOME:
      case HOME_STORE: {
        columns = [
          this.getColumnConfig('images'),
          this.getColumnConfig('stock'),
          this.getColumnConfig('barcode')
        ]
        if (hasSpecLevel) {
          columns.push(this.getColumnConfig('partNo'))
        }
        break
      }

      case E_DELIVERY:
      case ESD:
      case E_VOUCHER: {
        columns = [
          this.getColumnConfig('images'),
          this.getColumnConfig('stock')
        ]
        if (hasSpecLevel) {
          columns.push(this.getColumnConfig('partNo'))
        }
        break
      }

      case EXPRESS_24HR: {
        columns = [
          {
            ...this.getColumnConfig('images')
          },
          this.getColumnConfig('stock'),
          this.getColumnConfig('warehouseBarcode'),
          this.getColumnConfig(hasSpecLevel
            ? 'barcodeAndPartNo'
            : 'barcode'
          )
        ]
        break
      }
    }
    // 若有多層則插入多層結構之header及內容值
    const isFinishedExecuteStatus = executeStatus === PROPOSAL_EXECUTE_STATUS.FINISHED
    if (hasSpecLevel || isFinishedExecuteStatus) {
      columns.splice(1, 0, {
        title: (
          <TableTitle>
            {
              executeStatus === PROPOSAL_EXECUTE_STATUS.FINISHED && (
                <>
                  商品編號
                  <br />
                </>
              )
            }
            {
              hasSpecLevel && _.map(specs, (spec = {}, idx) => (
                <Fragment key={idx}>
                  {idx !== 0 && <br />}
                  {spec.name}
                </Fragment>
              ))
            }
          </TableTitle>
        ),
        dataIndex: 'specs',
        key: 'specs',
        className: styles.specs,
        width: 108,
        render: (value, rowItem, index) => {
          const specBlock = hasSpecLevel && (
            <Fragment key='spec'>
              <p
                key='primarySpec'
                className={styles.primarySpec}
              >
                {_.get(rowItem, 'modelDisplayName', '') || _.get(rowItem, 'primarySpec.values[0]', '')}
              </p>
              <p
                key='secondarySpec'
                className={styles.secondarySpec}
              >
                {_.get(rowItem, 'displayName', '') || _.get(rowItem, 'spec.values[0]', '')}
              </p>
            </Fragment>
          )
          const children = (
            <>
              {
                executeStatus === PROPOSAL_EXECUTE_STATUS.FINISHED && (
                  <p
                    key='productItemId'
                    className={styles.primarySpec}
                  >
                    {_.get(rowItem, 'itemId', '')}
                  </p>
                )
              }
              {specBlock}
            </>
          )
          return this.makeColumnObject(false, rowItem, index, isExpiringItem, readOnly, children)
        }
      })
    }
    if (!_.isEmpty(columns)) {
      // set the width of last column to auto
      columns[columns.length - 1].width = null
    }
    return columns
  }

  onExpandedRowsChange = rows => {
    // disable the control in rc-table
    return null
  }

  /* 按下商品圖片功能即展開圖片上傳功能 */
  onExpandedRowRender = (rowItem, index, indent, expanded) => {
    const { readOnly } = this.props
    if (expanded) {
      const { modelField } = rowItem
      const uploaderId = `table-row-${index}-image-uploader`
      const fieldName = `${modelField}.images`

      return (
        <Field
          name={fieldName}
          data-role={uploaderId}
          component={ImageUploaderField}
          disabled={readOnly}
          onUpdate={handleImageFileUpdate}
          onFinish={handleImageFileFinish}
          validate={validateModelImages}
        />
      )
    }
    return null
  }

  render () {
    const {
      data,
      expandedRowKeys = []
    } = this.props

    const columns = this.getColumns()

    return _.isEmpty(data)
      ? null
      : (
        <div className={styles.AttributeTable}>
          <Table
            data-role='attribute-table'
            prefixCls='attribute-table'
            data={data}
            columns={columns}
            pagination={false}
            expandIconAsCell={false}
            expandRowByClick={false}
            expandedRowKeys={expandedRowKeys}
            rowClassName={record => {
              switch (record.rowType) {
                case tableRowType.ROW_MODEL_TOP:
                  return styles.rowModelTop
                case tableRowType.ROW_MODEL_ITEM:
                  return styles.rowModelItem
                case tableRowType.ROW_INFORM:
                  return styles.rowInform
                case tableRowType.ROW_INFORM_HIDE:
                  return 'hidden'
              }
              return ''
            }}
            expandedRowRender={this.onExpandedRowRender}
            expandIcon={() => null}
            onExpandedRowsChange={this.onExpandedRowsChange}
          />
        </div>
      )
  }
}

const buildInformItem = (item, shouldShow, warehouseProductName) => {
  const rowType = shouldShow ? tableRowType.ROW_INFORM : tableRowType.ROW_INFORM_HIDE
  const informItem = Object.assign({}, item, {
    warehouseProductName,
    rowType
  })
  informItem.key = item.key + '-inform'
  return informItem
}

const buildTableData = (data, hasSpecLevel, props) => {
  const {
    models = [],
    specs = [],
    id: productId
  } = data
  const {
    proposalType,
    productName,
    shipTypeId: originShipTypeId,
    isProductNameChanged,
    isExpiringItem
  } = props
  const shipTypeId = +originShipTypeId
  const modelsLength = _.size(models)
  const specSize = _.size(specs)
  const singleLayerSpec = specSize === 1

  let maxModelDisplayNameLength = 0
  const modelItemTableData = _.reduce(
    models,
    (acc, model, modelIndex) => {
      const {
        displayName,
        images = [],
        spec = {},
        items = []
      } = model
      const itemsLength = _.size(items)

      _.map(
        items,
        (item, itemIndex) => {
          const {
            rowKey,
            displayName: itemDisplayName = undefined,
            warehouseProductName = '',
            spec: itemSpec = {},
            id: itemId
          } = item
          const tablePrefixField = getAttrTableFieldPrefixByLevel(hasSpecLevel)
          const modelField = `${tablePrefixField}.models[${modelIndex}]`
          const fieldName = `${modelField}.items[${itemIndex}]`
          const modelTop = itemIndex === 0
          const copyStockToModel = hasSpecLevel && singleLayerSpec
          let enableTopRowFunction = false
          if (modelTop && hasSpecLevel) {
            if (copyStockToModel) {
              // 單層會有多個model各有一個item，故只需要顯示第一組model
              enableTopRowFunction = modelsLength > 1 && modelIndex === 0
            } else {
              // 多層會有多個model各有多個item，故只需要顯示每組model的第一個item
              enableTopRowFunction = (itemsLength > 1 && modelsLength > 1)
            }
          }

          const tableItem = {
            itemId: !hasSpecLevel ? productId : itemId,
            rowType: modelTop ? tableRowType.ROW_MODEL_TOP : tableRowType.ROW_MODEL_ITEM,
            key: rowKey,
            dataIndex: rowKey,
            enableTopRowFunction,
            copyStockToModel,
            fieldName,
            tablePrefixField,
            modelField,
            modelsLength,
            modelIndex,
            itemIndex,
            itemsLength,
            modelDisplayName: displayName,
            primarySpec: spec,
            warehouseProductName,
            images
          }

          if (itemSpec) {
            tableItem.spec = itemSpec
          }

          if (itemDisplayName) {
            tableItem.displayName = itemDisplayName
          }
          itemIndex !== 0 && delete tableItem.images

          if (maxModelDisplayNameLength < _.get(tableItem, 'modelDisplayName.length', 0)) {
            maxModelDisplayNameLength = tableItem.modelDisplayName.length
          }

          acc.push(tableItem)
        })

      return acc
    }, [])

  // 進倉用商品名稱(warehouseProductName)在介面上的處理, 只能是另一行table row, 必須把資料拆開餵給Antd table
  const finalTableData = []
  _.forEach(modelItemTableData, item => {
    /**
     * 正常的table row資料
     */
    const { warehouseProductName } = item
    delete item.warehouseProductName // 正常顯示資料的table row不可以有這個資料(UI是拿這個欄位來判斷)
    finalTableData.push(item)

    if (productName && proposalType) { // 防範空table時期的檢查
      const isNewListing = isNewListingProposal(proposalType)
      if (isNewListing && shipTypeId === PRODUCT_SHIP_TYPE.EXPRESS_24HR) {
        let entireName = productName
        if (specSize > 0) {
          const modelName = item.modelDisplayName || _.get(item, 'primarySpec.values[0]', '') // 第一層屬性名稱
          const itemName = specSize === 2 ? item.displayName || _.get(item, 'spec.values[0]', '') : '' // 第二層屬性名稱 (if available)
          entireName = `${productName}-${modelName}` + (itemName ? `-${itemName}` : '') // 完整的名稱
        }

        const countLimit = isExpiringItem ? MAX_PRODUCT_NAME_IN_EXPRESS_24HR - EXPIRING_NOTE.STR.length : MAX_PRODUCT_NAME_IN_EXPRESS_24HR
        let shouldShow = false
        let showName = ''
        if (isProductNameChanged) {
          showName = entireName
          if (entireName.length > countLimit) {
            shouldShow = true
          }
        } else {
          showName = warehouseProductName || entireName
          if (entireName.length > countLimit) {
            shouldShow = true
          }
        }

        finalTableData.push(buildInformItem(item, shouldShow, showName))
      }
    }
  }) // _.forEach

  return finalTableData
}

/**
 * 空的 product object ，
 * 為了長出空的 attributeTable
 */
const emptyProduct = {
  models: [
    {
      items: [
        {
          stock: '0',
          rowKey: 'f5049b21-feec-54a0-8276-636c272dcd30',
          hasWarehouseBarcode: false
        }
      ],
      shareImageModel: false,
      images: []
    }
  ],
  expandedRowKeys: [],
  shareMediaBetweenModels: false,
  id: null
}

const EmptyAttributeTable = props => {
  const emptyTableData = buildTableData(emptyProduct, false, props)

  return (
    <AttributeTable
      {...props}
      hasSpecLevel={false}
      data={emptyTableData}
    />
  )
}

const renderAttributeTable = params => {
  const { transientField = '' } = params

  /**
   * user 還沒有選擇規格表的時候，
   * 需要有一個空的 AttributeTable 佔位
   */
  if (transientField === INVALID_TRANSIENT_KEY) {
    return (
      <EmptyAttributeTable
        {...params}
        readOnly
      />
    )
  }

  const {
    tableFieldPrefix,
    product = {},
    transientModel,
    shipTypeId,
    isExpiringItem,
    isProductNameChanged,
    forceInitTable,
    ...props
  } = params

  const { withSpecLevel: hasSpecLevel } = determineSpecLevel(transientModel.hasSpecLevel)
  const modelItemTableData = buildTableData(product, hasSpecLevel, params)

  const {
    specs = [],
    expandedRowKeys
  } = product

  return (
    <AttributeTable
      {...props}
      tableFieldPrefix={tableFieldPrefix}
      expandedRowKeys={expandedRowKeys}
      transientModel={transientModel}
      shipTypeId={shipTypeId}
      hasSpecLevel={hasSpecLevel}
      isExpiringItem={isExpiringItem}
      specs={specs}
      forceInitTable={forceInitTable}
      data={modelItemTableData}
    />
  )
}

class AttributeTableField extends Component {
  constructor (props) {
    super(props)
    this.state = {
      initProductName: props.productName,
      isProductNameChanged: false,
      forceInitTable: false
    }
  }

  componentWillReceiveProps (nextProps) {
    const { meta } = nextProps
    const { initProductName, isProductNameChanged } = this.state

    if (typeof initProductName === 'undefined' && !_.isEmpty(nextProps.productName)) {
      this.setState({
        initProductName: nextProps.productName
      })
    }

    // 表單儲存過後要重設狀態(儲存後meta會清空)
    if (isProductNameChanged && _.isEmpty(meta)) {
      this.setState({
        initProductName: this.props.productName,
        isProductNameChanged: false
      })
      return
    }

    /**
     * 處理"進倉用商品名稱"的顯示內容
     * NewListing + 快速到貨 + 長度超過50 = 顯示此欄位
     * 如果顯示此欄位, 所有會影響進倉欄位內容的相關欄位變更前, 顯示API的內容, 變更後顯示UI計算的內容, 並且必須跟所有相關欄位連動
     * 相關的連動欄位列表:
     *   商品名稱(product name)
     *   是否即期品
     *   有沒有選項
     *   屬性視窗：
     *    加減屬性
     *    加減屬性層數
     *    改變屬性內容
     *    從屬性視窗改商品名稱(product name)
     * 資料變更前, 為了簡化判定, 簡單以reduxForm meta是否visited來作為判斷依據
     */
    if (!isProductNameChanged && !_.isEmpty(initProductName)) {
      const formSectionName = getScopedShipTypeSectionName({ shipType: PRODUCT_SHIP_TYPE.EXPRESS_24HR }) // now shipTypeFormSection.shipType61
      const isVisited = _.get(meta, 'product.name', false) // 更動了product name ?
      const isSpecSettingModalVisited = _.get(meta, `${this.props.transientField}.spec`, false) // 更動了商品屬性設定視窗 ?
      const isExpiringItemVisited = !!_.get(meta, `${formSectionName}.product.isExpiringItem`, false) // 即期品被改變了 ?

      if ((isVisited && initProductName !== nextProps.productName) || isSpecSettingModalVisited || isExpiringItemVisited) {
        this.setState({
          isProductNameChanged: true,
          forceInitTable: true // initTable階段才會真正去設定reduxForm的值, 設定過後首次顯示的內容才會正確
        })
      }
    } else if (isProductNameChanged &&
      (this.props.productName !== nextProps.productName || this.props.showExpiringAddon !== nextProps.showExpiringAddon) &&
      !this.forceInitTable) {
      this.setState({
        forceInitTable: true // initTable階段才會真正去設定reduxForm的值, 設定過後首次顯示的內容才會正確
      })
    } else if (this.state.forceInitTable === true) {
      this.setState({
        forceInitTable: false // 後續顯示的數值是由user input來更新, 不用再由程式去設定reduxForm的內容
      })
    }
  }

  render () {
    // Table data is generated from AttributeSpecField
    const { hasSpecLevel } = this.props.transientModel
    const { isProductNameChanged, forceInitTable } = this.state
    const tableFieldPrefix = `${getAttrTableFieldPrefixByLevel(hasSpecLevel)}`
    const formKeyIsExpiringItem = getScopedShipTypeSectionName({
      shipType: PRODUCT_SHIP_TYPE.EXPRESS_24HR
    })

    return (
      <FormValueSelector fieldName={tableFieldPrefix}>
        {product => {
          return (
            <FormValueSelector
              selector={(select) => ({
                productId: select('product.id'),
                executeStatus: select('executeStatus'),
                isExpiringItem: select(`${formKeyIsExpiringItem}.product.isExpiringItem`) && select('setting.showExpiringAddon'),
                readOnly: select('setting.readOnly')
              })}
            >
              {
                values => {
                  const {
                    productId,
                    isExpiringItem,
                    executeStatus,
                    readOnly
                  } = values

                  return renderAttributeTable({
                    ...this.props,
                    product: {
                      ...product,
                      id: productId
                    },
                    tableFieldPrefix,
                    executeStatus,
                    isExpiringItem,
                    isProductNameChanged,
                    forceInitTable,
                    readOnly
                  })
                }
              }
            </FormValueSelector>
          )
        }}
      </FormValueSelector>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    flags: state.flags
  }
}

const AttributeTableFieldWithFlag = connect(
  mapStateToProps,
  {}
)(AttributeTableField)

export default AttributeTableFieldWithFlag
